export const UPDATE_TRANSLATIONS = "UPDATE_TRANSLATIONS";

export const UPDATE_PRIVACY_POLICY_LINK = "UPDATE_PRIVACY_POLICY_LINK";
export const UPDATE_LANGUAGE_LOCALE = "UPDATE_LANGUAGE_LOCALE";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const UPDATE_USER_SEARCH_RESULTS = "UPDATE_USER_SEARCH_RESULTS";
export const ADD_EMAILS_SENT = "ADD_EMAILS_SENT";
export const CHANGE_ALERT_STATUS = "CHANGE_ALERT_STATUS";
export const THROW_ERROR = "THROW_ERROR";
export const THROW_BANNED_WORD_ERROR = "THROW_BANNED_WORD_ERROR";
export const UPDATE_COMMENT_INFO = "UPDATE_COMMENT_INFO";
export const MODAL_DISPLAY = "MODAL_DISPLAY";
export const TOGGLE_PREVIEW = "TOGGLE_PREVIEW";
export const ADD_USER_COMMENT = "ADD_USER_COMMENT";
export const ADD_COMMENT_UTM_SOURCE = "ADD_COMMENT_UTM_SOURCE";
export const ADD_USER_NAME = "ADD_USER_NAME";
export const TOGGLE_IMAGE_LOADING = "TOGGLE_IMAGE_LOADING";
export const TOGGLE_SPINNER = "TOGGLE_SPINNER";
export const UPDATE_INPUT_AREA_HEIGHT = "UPDATE_INPUT_AREA_HEIGHT";
export const ADD_DUPLICATE_INFO = "ADD_DUPLICATE_INFO";
export const TOGGLE_DELAY_DISPLAY_ALERT = "TOGGLE_DELAY_DISPLAY_ALERT";
export const ADD_RESTRICTED_EMAILS = "ADD_RESTRICTED_EMAILS";
export const UPDATE_USER_SEARCH_RESULTS_HEIGHT =
  "UPDATE_USER_SEARCH_RESULTS_HEIGHT";
export const CHANGE_USER_SEARCH_STATUS = "CHANGE_USER_SEARCH_STATUS";
export const CHANGE_USER_SEARCH_IN_VIEW = "CHANGE_USER_SEARCH_IN_VIEW";
export const ADD_AUTO_COMPLETE_SELECTED_USER =
  "ADD_AUTO_COMPLETE_SELECTED_USER";
export const REMOVE_SELECTED_USER = "REMOVE_SELECTED_USER";
export const CHANGE_SELECTED_USER = "CHANGE_SELECTED_USER";
export const REMOVE_ALL_SELECTED_USERS = "REMOVE_ALL_SELECTED_USERS";
export const TOGGLE_DISPLAY_FINAL_MESSAGE = "TOGGLE_DISPLAY_FINAL_MESSAGE";
export const TOGGLE_VIDEO_UPLOAD_SUCCESS = "TOGGLE_VIDEO_UPLOAD_SUCCESS";
export const ADD_UPLOADED_PHOTO = "ADD_UPLOADED_PHOTO";
export const UPDATE_SCALE_FACTOR = "UPDATE_SCALE_FACTOR";
export const DELETE_UPLOADED_PHOTO = "DELETE_UPLOADED_PHOTO";
export const ROTATE_PHOTO = "ROTATE_PHOTO";
export const ADD_VIDEO_UPLOAD_CONFIG = "ADD_VIDEO_UPLOAD_CONFIG";
export const ADD_VIDEO_FILE_NAME = "ADD_VIDEO_FILE_NAME";
export const ADD_USER_EMAIL = "ADD_USER_EMAIL";
export const TOGGLE_INVITES_INFO_RECEIVED = "TOGGLE_INVITES_INFO_RECEIVED";
export const TOGGLE_COMMENTS_INFO_RECEIVED = "TOGGLE_COMMENTS_INFO_RECEIVED";
export const UPDATE_AUTO_COMPLETE_TEXT_AREA_VALUE =
  "UPDATE_AUTO_COMPLETE_TEXT_AREA_VALUE";
